import { NavLink, useLocation, matchPath } from "react-router-dom";
import * as LucideIcons from "lucide-react";
import * as VscIcons from "react-icons/vsc";

const SidebarLink = ({ link, iconName, isExpanded, onClick }) => {
  const location = useLocation();

  let Icon = LucideIcons[iconName] || VscIcons[iconName];
  const matchRoute = (route) => matchPath({ path: route }, location.pathname);

  return (
    <NavLink
      to={link.path}
      onClick={onClick}
      className={({ isActive }) =>
        `group relative flex items-center gap-3 rounded-lg px-3 py-3 transition-all duration-200 ${
          isActive
            ? "bg-gradient-to-br from-slate-100 to-blue-100 text-slate-700"
            : "text-slate-700 hover:bg-gradient-to-br hover:from-slate-50 hover:to-blue-100 hover:text-slate-700"
        } ${!isExpanded ? "justify-center" : ""}`
      }
    >
      {Icon && <Icon className="h-5 w-5" />}
      {isExpanded && <span>{link.name}</span>}

      {/* Tooltip on hover when collapsed */}
      {!isExpanded && (
        <span className="absolute left-full ml-2 rounded-md bg-slate-800 px-2 py-1 text-xs text-white opacity-0 group-hover:opacity-100">
          {link.name}
        </span>
      )}
    </NavLink>
  );
};

export default SidebarLink;
